__turbopack_context__.v({
  "button": "LbS3Xa_button",
  "wrapper": "LbS3Xa_wrapper",
});
